import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get } from '~/actions/orderNew';
import { format } from '~/utils/format';
import Tag from '~/components/Tag';
import Container from '~/components/Container';
import Title from '~/components/Title';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stockPage: 1,
    };
  }

  componentDidMount() {
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderRow(id) {
    const { order, articles } = this.props;
    const goal = (order.articleIds || {})[id] || 0;
    const goalSet = typeof (order.articleIds || {})[id] === 'number';
    const stock = Object.values(articles)
      .filter(i => i.articleId === id)
      .reduce((s, v) => s + v.count, 0);
    return (
      <div key={id} className={style.stockRow}>
        <div className={style.title}>
          <Tag
            id={id}
            type="article"
          />
        </div>
        <div className={style.goal}>{goalSet ? goal : '-'}</div>
        <div className={[style.count, stock === goal && style.green, stock > goal && style.red].join(' ')}>
          {stock}
        </div>
      </div>
    );
  }

  renderDialog() {
    const { order, containers, articles } = this.props;
    const goal = (order.articleIds || {});
    const articleIds = [...new Set([
      ...Object.values(articles).map(i => i.articleId),
      ...Object.keys(goal),
      ...Object.values(containers).reduce((s, v) => [...s, ...Object.keys(v.articleIds || {})], []),
    ])];
    return (
      <div>
        <Button style={{ float: 'right' }} label="Edit details" className={style.buttonEdit} onClick={() => this.context.dialogPush('orderEdit', { id: order.id })} />
        <Title style={{ marginBottom: '10px' }}>Information</Title>
        <div>Order #{order.sku}</div>
        <div>Reference: {order.reference}</div>
        <div>Partynuts ID: {order.partynutsId || 'Not set'}</div>
        <div>Notes:</div>
        <div style={{ marginBottom: '5px', fontSize: '10px' }}>{order.notes || 'No notes'}</div>
        <div>ETA: {format.date(order.eta)}</div>
        <div>Customer: <Tag type="customer" id={order.customerId} /></div>
        <Title style={{ margin: '10px 0' }}>Containers</Title>
        {Object.values(containers).map(container =>
          <Container key={container.id} id={container.id} className={style.task} />)}
        {!Object.values(containers).length && <div>No containers</div>}
        {articleIds.length !== 0 && (<div className={style.range}>
          <Button
            primary
            icon="chevron_left"
            onClick={() => this.setState({ stockPage: this.state.stockPage - 1 })}
            disabled={this.state.stockPage < 2}
          />
          &nbsp;{this.state.stockPage}/{Math.ceil(articleIds.length / 10)}&nbsp;
          <Button
            primary
            icon="chevron_right"
            onClick={() => this.setState({ stockPage: this.state.stockPage + 1 })}
            disabled={this.state.stockPage >= Math.ceil(articleIds.length / 10)}
          />
        </div>)}
        <Title style={{ margin: '10px 0' }}>Articles</Title>
        {articleIds.length > 0 && <div className={style.stockRow}>
          <div className={style.title}>Article</div>
          <div className={style.goal} style={{ fontSize: '14px' }}>Target</div>
          <div className={style.count} style={{ fontSize: '14px' }}>Stock</div>
        </div>}
        {articleIds
          .slice((this.state.stockPage - 1) * 10, this.state.stockPage * 10)
          .map(id => this.renderRow(id))}
        {articleIds.length === 0 && <div>No articles in stock</div>}
        {order.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.order && '404'}
            {!this.state.loading && this.props.order && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const order = state.getIn(['orderNew', 'items', props.data.id]) && state.getIn(['orderNew', 'items', props.data.id]).toJS();
  const containers = state.getIn(['containers', 'items'])
    .filter(i => i.get('orderId') === props.data.id && i.get('removed') !== true)
    .toJS();
  const articles = state.getIn(['stock', 'items']).filter(i => Object.keys(containers).includes(i.getIn(['location', 'id']))).toJS();
  return { order, containers, articles };
};

export default connect(mapStateToProps)(Dialog);




// WEBPACK FOOTER //
// ./app/dialogs/Order/index.js